const uspsSwiper = new Swiper(".section--usps .swiper", {
    touchStartPreventDefault: false,
    loop: false,
    slidesPerView: 2,
    spaceBetween: 0,
    breakpoints: {
        768: {
            slidesPerView: 'auto',
            allowTouchMove: false,
            autoplay: false
        },
    },
    autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    }
});

const featuredProductsSwiper = new Swiper(".section--featured-products .swiper", {
    touchStartPreventDefault: false,
    loop: false,
    slidesPerView: 1.25,
    spaceBetween: 0,
    breakpoints: {
        992: {
            slidesPerView: 'auto',
            allowTouchMove: false,
            autoplay: false
        },
    },
    autoplay: {
        delay: 2500,
        disableOnInteraction: true,
    }
});

const productMediaThumbsSwiper = new Swiper(".section--main-product .swiper--thumbs", {
    centeredSlides: true,
    centeredSlidesBounds: true,
    direction: "horizontal",
    slidesPerView: 5,
    spaceBetween: 10,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    autoHeight: false,
});

const productMediaSwiper = new Swiper(".section--main-product .swiper--main", {
    direction: "horizontal",
    spaceBetween: 10,
    autoScrollOffset: 1,
    keyboard: {
        enabled: true,
    },
    thumbs: {
        swiper: productMediaThumbsSwiper,
    },
    992: {
        touchStartPreventDefault: false,
        effect: 'fade',
        allowTouchMove: false,
        fadeEffect: { crossFade: true },
    },
});

let swiperPaginationElements = document.getElementsByClassName('swiper-pagination');
let swiperPaginationPositions = [];

for (let i = 0; i < swiperPaginationElements.length; i++) {
    let currentPagination = swiperPaginationElements[i];
    let currentPaginationPosition = [
        currentPagination.offsetTop,
        currentPagination.offsetTop + currentPagination.offsetHeight
    ]
    swiperPaginationPositions.push(currentPaginationPosition);
}

const floatingSocials = document.querySelector('#floating-socials');

if( floatingSocials != null ) {
    window.addEventListener("scroll", function () {
        let windowPostion = window.scrollY + window.innerHeight;
        const footerPostion = window.scrollY + document.querySelector('#footer').getBoundingClientRect().top;
        let floatingSocialsPosition = window.scrollY + floatingSocials.getBoundingClientRect().top;

        let hideFloatingSocials = false;

        for (let i = 0; i < swiperPaginationPositions.length; i++) {
            let currentPaginationPosition = swiperPaginationPositions[i];
            if (floatingSocialsPosition >= currentPaginationPosition[0] && floatingSocialsPosition <= currentPaginationPosition[1]) {
                hideFloatingSocials = true;
            }
        }

        if (windowPostion >= 320 && windowPostion >= footerPostion) {
            hideFloatingSocials = true;
        }

        if (hideFloatingSocials) {
            floatingSocials.classList.add('hide');
        } else {
            floatingSocials.classList.remove('hide');
        }
    });
}

document.querySelector('.shopify-challenge__button').classList.add('btn-primary', 'mt-3');
